import {
  SET_CONVERSATION_ID,
  CLEAR_CONVERSATION_ID,
  CLEAR_ALL_CONVERSATIONS,
  AiConversationsActionTypes,
} from './aiConversationsTypes';

const SESSION_STORAGE_KEY = 'aiConversationsCache';

export const setConversationId = (targetFieldId: string, conversationId: string): AiConversationsActionTypes => ({
  type: SET_CONVERSATION_ID,
  payload: {
    targetFieldId,
    conversationId,
  },
});

export const clearConversationId = (targetFieldId: string): AiConversationsActionTypes => ({
  type: CLEAR_CONVERSATION_ID,
  payload: {
    targetFieldId,
  },
});

export const clearAllConversations = (): AiConversationsActionTypes => ({
  type: CLEAR_ALL_CONVERSATIONS,
});

// Utility function to manually clear sessionStorage
export const clearAiConversationsFromSessionStorage = (): void => {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch (err) {
    console.warn('Failed to clear AI conversations from sessionStorage:', err);
  }
};

// Selector to get conversation ID for a specific field
export const getConversationId = (
  conversationCache: { [key: string]: string },
  targetFieldId: string,
): string | null => {
  return conversationCache[targetFieldId] || null;
};

// Selector to check if a field has an existing conversation
export const hasExistingConversation = (
  conversationCache: { [key: string]: string },
  targetFieldId: string,
): boolean => {
  return !!conversationCache[targetFieldId];
};
